const tourismAdminAbility = (can, cannot) => {
  can('manage', 'TourismAdmin');
  can('manage', 'NotificationBatch');
};

export default tourismAdminAbility;
